import { AlertInputs } from './alert.inputs';

export class Alert {
  readonly componentInputs: Omit<Partial<AlertInputs>, 'header'>;

  constructor(readonly inputs: Partial<AlertInputs>) {
    Object.assign(this.inputs, { title: this.inputs.header }, this.inputs);

    const { header, ...componentInputs } = this.inputs;
    this.componentInputs = componentInputs;
  }
}
